import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/components/Auth'
import Login from '@/components/Login'
import register from '@/components/register'
import registered from '@/components/registered'
import signupSystem from '@/pages/signupSystem'
import auditMsg from '@/pages/auditMsg'
import enrollingMsg from '@/pages/enrollingMsg'
import parenting from '@/pages/parenting'
import personManage from '@/pages/personManage'

import personal from '@/pages/personal'
import group from '@/pages/group'
import UnionGroup from '@/pages/UnionGroup'
import hotel from '@/pages/hotel'
import paymentRecord from '@/pages/paymentRecord'
import pay from '@/pages/pay'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Auth,
      children:[{
      	  path: '/',
	      name: 'Login',
	      component: Login,
	      },
	      {
		      path: '/register',
		      name: 'register',
		      component:register
	     },
	      {
		      path: '/registered',
		      name: 'registered',
		      component:registered
	     }
	    ]
    },
    {
    		path:'/signupSystem',
    		name:'signupSystem',
    		component:signupSystem,
    		children:[
            {
              path:'/auditMsg',
              component:auditMsg
            },
            {
              path:'/personManage',
              component:personManage
            },
            {
	    				path:'/personal',
	    				component:personal,

	    			},{
	    				path:'/group',
	    				name:'group',
	    				component:group,
	    			},{
	    				path:'/parenting',
	    				name:'parenting',
	    				component:parenting
	    			},
	    			{
	    				path:'/UnionGroup',
	    				name:'UnionGroup',
	    				component:UnionGroup,
	    			},{
	    				path:'/hotel',
	    				name:'hotel',
	    				component:hotel,
	    			},{
	    				path:'/paymentRecord',
	    				name:'paymentRecord',
	    				component:paymentRecord,
	    			}
    		]
    },
    {
    		path:'pay',
    		name:'pay',
    		component:pay
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js